import * as React from "react"
import { useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"
// import AniLink from "gatsby-plugin-transition-link/AniLink"
import { Link, navigate } from "gatsby"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import {
  Navbar,
  Nav,
  NavDropdown,
  Form,
  FormControl,
  Button,
} from "react-bootstrap"
import logo from "../images/new_website/logo.svg"
import coloredLogo from "../images/new_website/invimaticColorLogo.svg"
// replace with invimatic-christmas-logo.svg for christmas official logo
import hamburger from "../images/new_website/gifs/jsonGifs/hamburger.json"
import searchicon from "../images/new_website/landing/explore-icon.svg"
import serviceMenuCasestudy from "../images/new_website/service-menu-casestudy.jpg"
import * as allImages from "../utils/images"
import {
  Container,
  Divider,
  List,
  ListItem,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Stack,
  Box,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  useTheme,
} from "@mui/material"
import { IconButton } from "@mui/material"
import Drawer from "@mui/material/Drawer"
import CloseIcon from "@mui/icons-material/Close"
import MenuIcon from "@mui/icons-material/Menu"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"

import { styled } from "@mui/system"
import { useLocation } from "@reach/router"

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: hamburger,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
}

const Header = ({ siteTitle, showBlueNavbar, showBlackNavbar, topPromotab }) => {
  const [isSticky, setIsSticky] = useState(false)
  const [ismobSticky, setIsmobSticky] = useState(false)
  // const location = useLocation();

  React.useEffect(() => {
    var h = document.querySelector(".cursor")

    document.body.onmousemove = function (e) {
      if (h) {
        h.style.setProperty(
          "background-position",
          e.clientX - 15 + "px " + (e.clientY - 15) + "px"
        )
      }
    }
  })

  React.useEffect(() => {
    const header = document.querySelector(".header")
    const navLinks = document.querySelectorAll(".nav-link")

    if (header && navLinks.length > 0) {
      navLinks.forEach(navLink => {
        navLink.addEventListener("mouseover", () => {
          header.classList.add("header-hovered")
        })

        navLink.addEventListener("mouseout", () => {
          header.classList.remove("header-hovered")
        })
      })
    }
  }, [])

  // TO DO: used to hide topPromotab when scrolled
  // useEffect(() => {
  //   const handleScroll = () => {
  //     const scrollY = window.scrollY
  //     const threshold = 50

  //     setIsSticky(scrollY > threshold)
  //     setIsmobSticky(scrollY > threshold)
  //   }

  //   window.addEventListener("scroll", handleScroll)

  //   return () => {
  //     window.removeEventListener("scroll", handleScroll)
  //   }
  // }, [])

  //mobile navigation
  const [isDrawerOpen, setDrawerOpen] = useState(false)

  const handleDrawerOpen = () => {
    setDrawerOpen(true)
  }

  const handleDrawerClose = () => {
    setDrawerOpen(false)
  }

  const [sidebarServiceMenuActiveItem, setSidebarServiceMenuActiveItem] = useState(1);
  const [sidebarIndustriesMenuActiveItem, setSidebarIndustriesMenuActiveItem] = useState(0)

  const ServiceMenuItems = [
    {
      name: "SOC 2 Compliances",
      subItems: [],
      url: "/soc-2-compliance/",
    },
    {
      name: "Product Engineering",
      subItems: [
        {
          item: "UI/UX Design",
          description:
            "Craft user-focused, scalable interfaces that elevate brand experiences.",
          url: "/ui-ux-design-solutions/",
        },
        {
          item: "Web Application (SaaS)",
          description:
            "Develop secure, scalable web apps with seamless integration and UX.",
          url: "/saas-application/",
        },
        {
          item: "Mobile Application",
          description:
            "Create innovative, high-performance mobile apps for iOS and Android.",
          url: "/solution-mobile-application/",
        },
        {
          item: "DevSecOps",
          description:
            "Integrate security throughout the software development lifecycle.",
          url: "/devsecops/",
        },
        {
          item: "Quality Assurance",
          description:
            "Ensure reliable software with comprehensive manual and automated testing.",
          url: "/quality-assurance-solutions/",
        },
      ],
    },
    {
      name: "Staff Augmentation",
      subItems: [],
      url: "/it-staff-augmentation-services-saas/",
    },
  ]

  const industryMenuItems = [
    {
      name: "Supply Chain, Logistics, & Manufacturing",
      url: "/transforming-logistics-and-inventory-management/",
      subItems: [
        {
          item: "Warehouse Management",
          description:
            "Custom WMS optimizing inventory, order processing, and operational efficiency.",
          url: "/solution-optimized-warehouse-management-systems/",
        },
        {
          item: "Fleet Management",
          description:
            "Tailored FMS improving fleet performance through analytics and optimization.",
          url: "/solution-elevate-your-fleet-management-with-advance-solutions/",
        },
        {
          item: "Travel Management",
          description:
            "Streamlined TMS automating corporate travel and expense management processes.",
          url: "/solution-transform-transportation-with-comprehensive-transportation-management-system/",
        },
        {
          item: "Order Management Systems",
          description:
            "Customized OMS ensuring order accuracy and efficient multi-channel fulfillment.",
          url: "/solution-transform-your-order-management-system/",
        },
        {
          item: "Manufacturing  Solutions",
          description:
            "Tailored software improving manufacturing processes, automation, and operational efficiency.",
          url: "/manufacturing-solutions-structure-of-the-Industry/",
        },
        {
          item: "Integration Solutions",
          description:
            "Seamless integration connecting systems for real-time data flow and visibility.",
          url: "/solution-transform-your-supply-chain-with-seamless-integration/",
        },
      ],
    },
    {
      name: "Automotive & Transportation",
      url: "/dealer-management-system-software-solutions/",
      subItems: [
        {
          item: "Dealer Management Systems",
          description:
            "Streamlined dealership operations managing sales, service, inventory, and customers.",
          url: "/dealership-management-system/",
        },
        {
          item: "Connected Vehicle Solutions",
          description:
            "Seamless vehicle connectivity enables diagnostics, updates, and fleet integration.",
          url: "/connected-vehicle-solutions/",
        },
        {
          item: "Vehicle Distribution Systems",
          description:
            "Manage distribution, forecasting, and inventory for efficient vehicle deliveries.",
          url: "/vehicle-distribution-systems/",
        },
        {
          item: "Mobility as a Service (MaaS) Solutions",
          description:
            "Unified platform integrating multiple transport modes for seamless mobility.",
          url: "/mobility-as-a-service/",
        },
        {
          item: "Integration Solutions",
          description:
            "Integrate automotive systems ensuring seamless data flow and communication.",
          url: "/custom-integration-technology-solutions/",
        },
      ],
    },
    {
      name: "Retail",
      url: "/retail-software-solutions/",
      subItems: [
        {
          item: "Omnichannel Retail Solutions",
          description:
            "Seamless integration across retail touchpoints for personalized shopping experiences.",
          url: "/omnichannel-retail-ecommerce-solutions/",
        },
        {
          item: "E-commerce Platform Development",
          description:
            "Custom e-commerce platforms with secure transactions and dynamic features.",
          url: "/ecommerce-development-services/",
        },
        {
          item: "Retail Inventory Management Solutions",
          description:
            "Tailored inventory management ensuring accuracy and supply chain visibility.",
          url: "/retail-inventory-management-solutions/",
        },
        {
          item: "Customer Experience Solutions",
          description:
            "Personalized systems to enhance engagement, loyalty, and brand satisfaction.",
          url: "/customer-engagement-solutions/",
        },
        {
          item: "Point of Sale (POS) Systems",
          description:
            "Advanced POS systems improving operations, analytics, and customer service.",
          url: "/point-of-sale-systems/",
        },
        {
          item: "Integration Solutions",
          description:
            "Unified systems for seamless data flow across retail platforms",
          url: "/integrated-solutions-for-retailers/",
        },
      ],
    },
    {
      name: "Travel & Hospitality",
      url: "/digital-transformation-in-travel-hospitality/",
      subItems: [
        {
          item: "Travel Booking Platforms",
          description:
            "Custom booking platforms optimizing travel operations and boosting conversions.",
          url: "/booking-management-solutions/",
        },
        {
          item: "Smart Hospitality Solutions",
          description:
            "AI-driven solutions optimizing operations and enhancing guest experiences.",
          url: "/hospitality-software-solutions/",
        },
        {
          item: "Restaurant Management System",
          description:
            "Custom RMS integrating with delivery, payment, and operations platforms.",
          url: "/restaurant-management-systems/",
        },
        {
          item: "Travel Management Software",
          description:
            "Custom TMS for seamless corporate, group, and leisure travel experiences.",
          url: "/travel-management-software/",
        },
        {
          item: "Integration Solutions",
          description:
            "Secure APIs and integrations for seamless travel ecosystem connectivity.",
          url: "/travel-api-integration-solutions/",
        },
      ],
    },
    {
      name: "HiTech",
      url: "/high-tech-cloud-security/",
      subItems: [
        {
          item: "Cloud Enablement Solutions",
          description:
            "End-to-end cloud management with security, scalability, and flexibility.",
          url: "/cloud-service-providers-end-to-end-management/",
        },
        {
          item: "Security Consultation Services",
          description:
            "Tailored strategies ensuring resilience, compliance, and data protection.",
          url: "/cyber-security-consultant-services/",
        },
        {
          item: "Enterprise Modernization",
          description:
            "Modernize legacy systems, automate processes, and adopt emerging technologies.",
          url: "/enterprise-modernization-services/",
        },
        {
          item: "Platforms",
          description:
            "Build seamless communication systems with unified voice, video, and messaging.",
          url: "/unified-communication-solutions-system-integration-services/",
        },
        {
          item: "Application Development",
          description:
            "Custom application solutions that align with business goals and transformation.",
          url: "/application-modernization-services/",
        },
      ],
    },
  ]

  const aboutMenuItems = [
    {
      name: "Company Overview",
      subItems: [],
      url: "/about#about_main_section/",
    },
    {
      name: "Invimatic Academy",
      subItems: [
        {
          item: "Knowledge Articles",
          url: "/invimatic-knowledge-centre-tech-trends/",
        },
      ],
    },
    {
      name: "Newsroom",
      subItems: [],
      url: "/press-releases/",
    },
    {
      name: "Magazine",
      subItems: [],
      url: "/magazine/",
    },
  ]

  return (
    <>
      <div className="banner">
        <header
          className={
            showBlueNavbar
              ? "showBlueNavbar"
              : showBlackNavbar
              ? "showBlackNavbar"
              : "header"
          }
          style={{top: topPromotab ? "50px" : "0px" }}
        >
          <nav
            className={`navbar navbar-expand-lg p-0 desktopNav deskShow me-auto ${
              isSticky ? "sticky" : ""
            }`}
          >
            <Container maxWidth="xl" className="container-fluid mainWrapper">
              <AnchorLink to="/" className="navbar-brand py-0">
                <img
                  src={coloredLogo}
                  className="logo-wrapper"
                  alt="Company Logo"
                />
              </AnchorLink>

              <div className="collapse navbar-collapse" id="navbarNavDropdown">
                <ul className="navbar-nav mt-2 mt-lg-0 cursor w-100">
                  {/* services menu */}
                  <li class="nav-item dropdown">
                    <a
                      class="nav-link"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{cursor: "default"}}
                    >
                      Services
                    </a>
                    <div class="dropdown-menu__wrapper">
                      <div
                        class="dropdown-menu"
                        aria-labelledby="navbarDropdown"
                      >
                        <Box display="flex" p={3}>
                          {/* Sidebar Menu */}
                          <List sx={{ width: "230px" }}>
                            {ServiceMenuItems.map((item, index) => (
                              <ListItem
                                key={item.name}
                                onClick={() => setSidebarServiceMenuActiveItem(index)}
                                // selected={location.pathname === menuItem.url}
                                sx={{
                                  borderLeft:
                                    index === sidebarServiceMenuActiveItem
                                      ? "3px solid #DC4C5A"
                                      : "unset",
                                  cursor: "pointer",
                                }}
                              >
                                <Link to={item.url ? item.url : "#"}>
                                  <Typography
                                    variant="h6"
                                    fontSize={16}
                                    color="#212529"
                                    fontWeight={
                                      index === sidebarServiceMenuActiveItem
                                        ? "700"
                                        : "normal"
                                    }
                                    sx={{
                                      "&:hover": {
                                        fontWeight: 700
                                      }
                                    }}
                                  >
                                    {item.name}
                                  </Typography>
                                </Link>
                              </ListItem>
                            ))}
                          </List>
                          {/* Submenu */}
                          <Box flex="1" ml={2}>
                            {ServiceMenuItems.find(
                              (item, index) => index === sidebarServiceMenuActiveItem
                            )?.subItems.length > 0 && (
                              <Box display="flex" alignItems="flex-start">
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "15px",
                                  }}
                                >
                                  {ServiceMenuItems.find(
                                    (item, index) =>
                                      index === sidebarServiceMenuActiveItem
                                  )?.subItems.map((subItem, index) => (
                                    <Link
                                      to={subItem.url}
                                      key={subItem.item}
                                      className="submenu-item"
                                    >
                                      <Stack>
                                        <Stack
                                          flexDirection="row"
                                          alignItems="flex-start"
                                          justifyContent="space-between"
                                        >
                                          <Typography
                                            variant="body1"
                                            fontSize={18}
                                            fontWeight="600"
                                            mb="14px"
                                          >
                                            {subItem.item}
                                          </Typography>
                                          <div className="display-hover-arrow">
                                            <Box className="hover-arrow">
                                              <img
                                                src={allImages.whiteArrow}
                                                alt={`${subItem.item} ' clickable'`}
                                              />
                                            </Box>
                                          </div>
                                        </Stack>
                                        {subItem.description && (
                                          <Typography
                                            variant="caption"
                                            lineHeight="16px"
                                            fontWeight="500"
                                          >
                                            {subItem.description}
                                          </Typography>
                                        )}
                                      </Stack>
                                    </Link>
                                  ))}
                                </Box>
                                {/* Case Study Card */}
                                <Box>
                                  <Link to="/soc-2-compliance-saas-provider/">
                                    <Card
                                      sx={{
                                        width: "300px",
                                        ml: 2,
                                        boxShadow: "unset",
                                        borderRadius: "6px",
                                        backgroundColor: "#F0F7FF",
                                      }}
                                    >
                                      <CardMedia
                                        component="img"
                                        height="auto"
                                        width="100%"
                                        image={serviceMenuCasestudy}
                                        alt="case study for mobile app"
                                        sx={{
                                          objectPosition: "top",
                                          objectFit: "fill",
                                        }}
                                      />
                                      <CardContent>
                                        <Typography variant="h5" fontSize={13}>
                                          Case Study
                                        </Typography>
                                        <Typography
                                          variant="h6"
                                          fontSize={18}
                                          fontWeight="600"
                                          lineHeight="20px"
                                          mt={1.5}
                                          display="flex"
                                          alignItems="flex-end"
                                        >
                                          Achieving SOC 2 Compliance for a
                                          Leading Customer Experience SaaS
                                          Provider
                                          <img
                                            src={allImages.promoArrow}
                                            alt="redirect arrow"
                                          />
                                        </Typography>
                                      </CardContent>
                                    </Card>
                                  </Link>
                                </Box>
                              </Box>
                            )}
                          </Box>
                        </Box>
                      </div>
                    </div>
                  </li>

                  {/* Industries menu */}
                  <li class="nav-item dropdown">
                    <a
                      class="nav-link"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{cursor: "default"}}
                    >
                      Industries
                    </a>
                    <div class="dropdown-menu__wrapper">
                      <div
                        class="dropdown-menu"
                        aria-labelledby="navbarDropdown"
                      >
                        <Box display="flex" p={3}>
                          {/* Sidebar Menu */}
                          <List sx={{ width: "230px" }}>
                            {industryMenuItems.map((item, index) => (
                              <ListItem
                                key={item.name}
                                onMouseOver={() => setSidebarIndustriesMenuActiveItem(index)}
                                sx={{
                                  borderLeft:
                                    index === sidebarIndustriesMenuActiveItem
                                      ? "3px solid #DC4C5A"
                                      : "unset",
                                  cursor: "pointer",
                                }}
                              >
                                <Link to={item.url ? item.url : "#"}>
                                  <Typography
                                    variant="h6"
                                    fontSize={16}
                                    color="#212529"
                                    fontWeight={
                                      index === sidebarIndustriesMenuActiveItem
                                        ? "700"
                                        : "normal"
                                    }
                                  >
                                    {item.name}
                                  </Typography>
                                </Link>
                              </ListItem>
                            ))}
                          </List>
                          {/* Submenu */}
                          <Box flex="1" ml={2}>
                            {industryMenuItems.find(
                              (item, index) => index === sidebarIndustriesMenuActiveItem
                            )?.subItems.length > 0 && (
                              <Box display="flex" alignItems="flex-start">
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "15px",
                                  }}
                                >
                                  {industryMenuItems.find(
                                    (item, index) =>
                                      index === sidebarIndustriesMenuActiveItem
                                  )?.subItems.map((subItem, index) => (
                                    <Link
                                      to={subItem.url}
                                      key={subItem.item}
                                      className="submenu-item"
                                    >
                                      <Stack>
                                        <Stack
                                          flexDirection="row"
                                          alignItems="flex-start"
                                          justifyContent="space-between"
                                        >
                                          <Typography
                                            variant="body1"
                                            fontSize={18}
                                            fontWeight="600"
                                            mb="14px"
                                          >
                                            {subItem.item}
                                          </Typography>
                                          <div className="display-hover-arrow">
                                            <Box className="hover-arrow">
                                              <img
                                                src={allImages.whiteArrow}
                                                alt={`${subItem.item} ' clickable'`}
                                              />
                                            </Box>
                                          </div>
                                        </Stack>
                                        {subItem.description && (
                                          <Typography
                                            variant="caption"
                                            lineHeight="16px"
                                            fontWeight="500"
                                          >
                                            {subItem.description}
                                          </Typography>
                                        )}
                                      </Stack>
                                    </Link>
                                  ))}
                                </Box>
                                {/* Case Study Card */}
                                <Box>
                                  <Link to="/soc-2-compliance-saas-provider/">
                                    <Card
                                      sx={{
                                        width: "300px",
                                        ml: 2,
                                        boxShadow: "unset",
                                        borderRadius: "6px",
                                        backgroundColor: "#F0F7FF",
                                      }}
                                    >
                                      <CardMedia
                                        component="img"
                                        height="auto"
                                        width="100%"
                                        image={serviceMenuCasestudy}
                                        alt="case study for mobile app"
                                        sx={{
                                          objectPosition: "top",
                                          objectFit: "fill",
                                        }}
                                      />
                                      <CardContent>
                                        <Typography variant="h5" fontSize={13}>
                                          Case Study
                                        </Typography>
                                        <Typography
                                          variant="h6"
                                          fontSize={18}
                                          fontWeight="600"
                                          lineHeight="20px"
                                          mt={1.5}
                                          display="flex"
                                          alignItems="flex-end"
                                        >
                                          Achieving SOC 2 Compliance for a
                                          Leading Customer Experience SaaS
                                          Provider
                                          <img
                                            src={allImages.promoArrow}
                                            alt="redirect arrow"
                                          />
                                        </Typography>
                                      </CardContent>
                                    </Card>
                                  </Link>
                                </Box>
                              </Box>
                            )}
                          </Box>
                        </Box>
                      </div>
                    </div>
                  </li>

                  {/* Insights menu */}
                  <li className="nav-item dropdown insightMenu">
                    <a
                      className="nav-link"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{cursor: "default"}}
                    >
                      Insights
                    </a>
                    <div className="insightsSubmenu">
                      <ul
                        id="submenufin"
                      >
                        <li>
                          <AnchorLink to="/blog/">
                            Blogs
                          </AnchorLink>
                        </li>
                        <li>
                          <AnchorLink
                            to="/case-studiesdata/"
                          >
                            Case Studies
                          </AnchorLink>
                        </li>
                        <li>
                          <AnchorLink to="/whitepapers/">
                            White Paper
                          </AnchorLink>
                        </li>
                        <li>
                          <AnchorLink to="/exclusives/">
                            SOC 2 Exclusives
                          </AnchorLink>
                        </li>
                        <li>
                          <AnchorLink to="/ebooks/">
                            eBooks
                          </AnchorLink>
                        </li>
                      </ul>
                    </div>
                  </li>

                  {/* About section */}
                  <li className="nav-item dropdown insightMenu">
                    <a
                      className="nav-link"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{cursor: "default"}}
                    >
                      About Us
                    </a>
                    <div className="insightsSubmenu" style={{maxWidth: "202px"}}>
                      <ul id="submenufin">
                        <li>
                          <AnchorLink to="/about#about_main_section/">Company Overview</AnchorLink>
                        </li>
                        <li className="academySection">
                          <span>Invimatic Academy &nbsp; &#8250;</span>
                          <ul className="academySubmenu">
                            <li>
                              <AnchorLink to="/invimatic-knowledge-centre-tech-trends/">Knowledge Articles</AnchorLink>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <AnchorLink to="/press-releases/">Newsroom</AnchorLink>
                        </li>
                        <li>
                          <AnchorLink to="/magazine/">Magazine</AnchorLink>
                        </li>
                      </ul>
                    </div>
                  </li>

                  <li className="nav-item">
                    <AnchorLink to="/careers/" className="nav-link">
                      Careers
                    </AnchorLink>
                  </li>
                </ul>
              </div>
              <div className="d-flex align-items-center lastHeaderSect">
                <AnchorLink
                  className="btn btn-primary contactBtn"
                  to="/contact/"
                >
                  Let's Talk
                </AnchorLink>
              </div>
            </Container>
          </nav>
          <Navbar
            className={`mobileNav navbar-dark ${ismobSticky ? "sticky" : ""}`}
            expand="xl"
          >
            <Container maxWidth="xl" className="container-fluid mainWrapper">
              <AnchorLink to="/" className="navbar-brand py-0">
                <img
                  src={coloredLogo}
                  className="logo-wrapper"
                  alt="Company Logo"
                />
              </AnchorLink>
              <Navbar.Toggle
                aria-controls="basic-navbar-nav"
                onClick={handleDrawerOpen}
              >
                <MenuIcon sx={{ fill: "#000" }} />
              </Navbar.Toggle>
              {/* <IconButton aria-label="search" sx={{ p: 0 }}>
                                <img src={searchicon} />
                            </IconButton> */}
            </Container>

            <Drawer
              anchor="right"
              open={isDrawerOpen}
              onClose={handleDrawerClose}
              className="mobileDrawer"
            >
              <Stack
                className="closeBtnBox"
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                p={3}
              >
                <AnchorLink to="/" className="navbar-brand py-0">
                  <img src={logo} className="logo-wrapper" alt="Company Logo" />
                </AnchorLink>
                <IconButton
                  sx={{ color: "#fff", p: 0 }}
                  onClick={handleDrawerClose}
                  aria-label="close drawer"
                >
                  <CloseIcon />
                </IconButton>
              </Stack>
              <Stack p={3} className="mobMenuAccordion">
                {/* Services */}
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ fill: "#fff" }} />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography
                      variant="subtitle1"
                      fontWeight={700}
                      color="#fff"
                    >
                      Services
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Divider
                      sx={{
                        borderWidth: 1,
                        borderColor: "#8BCCFF",
                        borderBottomWidth: "inherit",
                      }}
                    ></Divider>
                    {ServiceMenuItems.map((item, index) =>
                      item?.subItems?.length > 0 ? (
                        <Accordion key={index}>
                          <AccordionSummary
                            expandIcon={
                              <ExpandMoreIcon sx={{ fill: "#fff" }} />
                            }
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <Typography
                              variant="subtitle1"
                              fontSize={14}
                              fontWeight={700}
                              color="#8BCCFF"
                            >
                              {item.name}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Stack>
                              {item.subItems.map((subitem, index) => (
                                <Link to={subitem.url} key={subitem.item}>
                                  <Stack
                                    flexDirection="row"
                                    alignItems="flex-start"
                                    justifyContent="space-between"
                                  >
                                    <Typography
                                      variant="body1"
                                      fontSize={14}
                                      fontWeight="600"
                                      pt={1}
                                      pb={0.2}
                                    >
                                      {subitem.item}
                                    </Typography>
                                  </Stack>
                                </Link>
                              ))}
                            </Stack>
                          </AccordionDetails>
                        </Accordion>
                      ) : (
                        <Link to={item.url} key={item.item}>
                          <Stack
                            flexDirection="row"
                            alignItems="flex-start"
                            justifyContent="space-between"
                          >
                            <Typography
                              variant="body1"
                              fontSize={14}
                              fontWeight="600"
                              pt={1}
                              pb={0.2}
                            >
                              {item.name}
                            </Typography>
                          </Stack>
                        </Link>
                      )
                    )}
                  </AccordionDetails>
                </Accordion>
                
                {/* INDUSTRIES */}
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ fill: "#fff" }} />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography
                      variant="subtitle1"
                      fontWeight={700}
                      color="#fff"
                    >
                      Industries
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Divider
                      sx={{
                        borderWidth: 1,
                        borderColor: "#8BCCFF",
                        borderBottomWidth: "inherit",
                      }}
                    ></Divider>
                    {industryMenuItems.map((item, index) =>
                      (
                        <Accordion key={index}>
                          <AccordionSummary
                            expandIcon={
                              <ExpandMoreIcon sx={{ fill: "#fff" }} />
                            }
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <Typography
                              variant="subtitle1"
                              fontSize={14}
                              fontWeight={700}
                              color="#fff"
                            >
                              {item.url ? <Link to={item.url} style={{color: "#8BCCFF"}}>{item.name}</Link> : item.name}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Stack>
                              {item.subItems.map((subitem, index) => (
                                <Link to={subitem.url} key={subitem.item}>
                                  <Stack
                                    flexDirection="row"
                                    alignItems="flex-start"
                                    justifyContent="space-between"
                                  >
                                    <Typography
                                      variant="body1"
                                      fontSize={14}
                                      fontWeight="600"
                                      pt={1}
                                      pb={0.2}
                                    >
                                      {subitem.item}
                                    </Typography>
                                  </Stack>
                                </Link>
                              ))}
                            </Stack>
                          </AccordionDetails>
                        </Accordion>
                      )
                    )}
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ fill: "#fff" }} />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography
                      variant="subtitle1"
                      fontWeight={700}
                      color="#fff"
                    >
                      About Us
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Divider
                      sx={{
                        borderWidth: 1,
                        borderColor: "#8BCCFF",
                        borderBottomWidth: "inherit",
                      }}
                    ></Divider>
                    {aboutMenuItems.map((item, index) =>
                      item?.subItems?.length > 0 ? (
                        <Accordion key={index}>
                          <AccordionSummary
                            expandIcon={
                              <ExpandMoreIcon sx={{ fill: "#fff" }} />
                            }
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <Typography
                              variant="subtitle1"
                              fontSize={14}
                              fontWeight={700}
                              color="#8BCCFF"
                            >
                              {item.name}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Stack>
                              {item.subItems.map((subitem, index) => (
                                <Link to={subitem.url} key={subitem.item}>
                                  <Stack
                                    flexDirection="row"
                                    alignItems="flex-start"
                                    justifyContent="space-between"
                                  >
                                    <Typography
                                      variant="body1"
                                      fontSize={14}
                                      fontWeight="600"
                                      pt={1}
                                      pb={0.2}
                                    >
                                      {subitem.item}
                                    </Typography>
                                  </Stack>
                                </Link>
                              ))}
                            </Stack>
                          </AccordionDetails>
                        </Accordion>
                      ) : (
                        <Link to={item.url} key={item.item}>
                          <Stack
                            flexDirection="row"
                            alignItems="flex-start"
                            justifyContent="space-between"
                          >
                            <Typography
                              variant="body1"
                              fontSize={14}
                              fontWeight="600"
                              pt={1}
                              pb={0.2}
                            >
                              {item.name}
                            </Typography>
                          </Stack>
                        </Link>
                      )
                    )}
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ fill: "#fff" }} />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography
                      variant="subtitle1"
                      fontWeight={700}
                      color="#fff"
                    >
                      Insights
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className="submenuMenu">
                    <Divider
                      sx={{
                        borderWidth: 1,
                        borderColor: "#8BCCFF",
                        borderBottomWidth: "inherit",
                      }}
                    ></Divider>
                    <Stack>
                      <AnchorLink to="/blog/">
                        <Typography
                          variant="subtitle1"
                          fontSize={14}
                          fontWeight={700}
                          color="#8BCCFF"
                          pt={1}
                        >
                          Blogs
                        </Typography>
                      </AnchorLink>
                      <AnchorLink to="/case-studiesdata/">
                        <Typography
                          variant="subtitle1"
                          pt={1.5}
                          fontSize={14}
                          fontWeight={700}
                          color="#8BCCFF"
                        >
                          Case Studies
                        </Typography>
                      </AnchorLink>
                      <AnchorLink to="/whitepapers/">
                        <Typography
                          variant="subtitle1"
                          pt={1.5}
                          fontSize={14}
                          fontWeight={700}
                          color="#8BCCFF"
                        >
                          White Paper
                        </Typography>
                      </AnchorLink>
                      <AnchorLink to="/exclusives/">
                        <Typography
                          variant="subtitle1"
                          pt={1.5}
                          fontSize={14}
                          fontWeight={700}
                          color="#8BCCFF"
                        >
                          SOC 2 Exclusives
                        </Typography>
                      </AnchorLink>
                      <AnchorLink to="/ebooks/">
                        <Typography
                          variant="subtitle1"
                          pt={1.5}
                          fontSize={14}
                          fontWeight={700}
                          color="#8BCCFF"
                        >
                          eBooks
                        </Typography>
                      </AnchorLink>
                    </Stack>
                  </AccordionDetails>
                </Accordion>


                <AnchorLink to="/careers/" className="mobileMenu">
                  Careers
                </AnchorLink>
                <AnchorLink
                  className="btn btn-primary contactBtn"
                  to="/contact/"
                >
                  Let's Talk
                </AnchorLink>
              </Stack>
            </Drawer>
          </Navbar>
        </header>
      </div>
    </>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}
export default Header
